var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { useGetMyPipelineBySalesStageDashletQuery, useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery, useGetOpportunitiesByLeadSourceDashletsQuery, useGetOutcomeByMonthDashletQuery, useGetPipelineBySalesStageDashletQuery, useSaveDashletPreferencesMutation, useSearchDashletChartMutation, } from "@/store/api";
import { memo, useEffect, useState } from "react";
var ChartWidgetDisplay = function (_a) {
    var _b, _c, _d, _e;
    var item = _a.item, myDashlets = _a.myDashlets, chartData = _a.chartData, _f = _a.chartType, chartType = _f === void 0 ? "bar" : _f, title = _a.title, refresh = _a.refresh, rowId = _a.rowId, rowMeta = _a.rowMeta, value = _a.value;
    var outcomeByMonthDashlets = useGetOutcomeByMonthDashletQuery({}).data;
    var opportunitiesByLeadSourceDashlets = useGetOpportunitiesByLeadSourceDashletsQuery({}).data;
    var opportunitiesByLeadSourceByOutcomeDashlets = useGetOpportunitiesByLeadSourceByOutcomeDashletsQuery({}).data;
    var pipelineBySalesDashlets = useGetPipelineBySalesStageDashletQuery({}).data;
    var myPipelineBySalesStageDashlet = useGetMyPipelineBySalesStageDashletQuery({}).data;
    var _g = useSaveDashletPreferencesMutation(), saveDashletPreferences = _g[0], _h = _g[1], dashletLoad = _h.isLoading, isError = _h.isError;
    var searchDashletChart = useSearchDashletChartMutation()[0];
    var _j = useState(myDashlets), allDashlets = _j[0], setAllDashlets = _j[1];
    var getDashlets = function () {
        switch (title) {
            case "Outcome by Month":
                return outcomeByMonthDashlets;
            case "All Opportunities by Lead Source":
                return opportunitiesByLeadSourceDashlets;
            case "All Opportunities By Lead Source By Outcome":
                return opportunitiesByLeadSourceByOutcomeDashlets;
            case "Pipeline By Sales Stage":
                return pipelineBySalesDashlets;
            case "My Pipeline By Sales Stage":
                return myPipelineBySalesStageDashlet;
            default:
                return null;
        }
    };
    var currentRow = rowMeta.find(function (row) { return row.id === item.id; });
    var currentRowConfig = (currentRow === null || currentRow === void 0 ? void 0 : currentRow.searchedData)
        ? currentRow === null || currentRow === void 0 ? void 0 : currentRow.searchedData
        : null;
    var currentTimerRefresh = currentRow === null || currentRow === void 0 ? void 0 : currentRow.refresh;
    var currentSearchfields = (_c = (_b = currentRow === null || currentRow === void 0 ? void 0 : currentRow.chartData) === null || _b === void 0 ? void 0 : _b.searchFields) !== null && _c !== void 0 ? _c : null;
    var searchDashlet = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestData, result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestData = {};
                    currentSearchfields &&
                        Object.entries(currentSearchfields).forEach(function (_a) {
                            var _b, _c, _d, _e;
                            var key = _a[0], field = _a[1];
                            switch (key) {
                                case "obm_ids":
                                    requestData.obm_ids = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.selectedOptions.users;
                                    requestData.obm_date_start =
                                        ((_b = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _b === void 0 ? void 0 : _b.obm_date_start) || "";
                                    requestData.obm_date_end =
                                        ((_c = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _c === void 0 ? void 0 : _c.obm_date_end) || "";
                                    break;
                                case "lsbo_lead_sources":
                                    requestData.lsbo_ids = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.users;
                                    requestData.lsbo_lead_sources = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.leadSources;
                                    break;
                                case "pbls_ids":
                                    requestData.pbls_ids = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.users;
                                    requestData.pbls_lead_sources = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.leadSources;
                                    break;
                                case "pbss_sales_stages":
                                    requestData.pbss_sales_stages = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.salesStages;
                                    requestData.pbss_date_start =
                                        (currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange.pbss_date_start) || "";
                                    requestData.pbss_date_end =
                                        (currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange.pbss_date_end) || "";
                                    break;
                                case "mypbss_sales_stages":
                                    requestData.mypbss_sales_stages = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.salesStages;
                                    requestData.mypbss_date_start =
                                        ((_d = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _d === void 0 ? void 0 : _d.mypbss_date_start) || "";
                                    requestData.mypbss_date_end =
                                        ((_e = currentRowConfig === null || currentRowConfig === void 0 ? void 0 : currentRowConfig.dateRange) === null || _e === void 0 ? void 0 : _e.mypbss_date_end) || "";
                                    break;
                                default:
                                    break;
                            }
                        });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, searchDashletChart({ body: requestData }).unwrap()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 3:
                    err_1 = _a.sent();
                    console.error("Error searching dashlet chart:", err_1);
                    throw err_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getSearchedDashlet = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resultSearch, newChartData, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, searchDashlet()];
                case 1:
                    resultSearch = _b.sent();
                    newChartData = (_a = resultSearch === null || resultSearch === void 0 ? void 0 : resultSearch.data) === null || _a === void 0 ? void 0 : _a.dashlets;
                    return [2 /*return*/, newChartData];
                case 2:
                    error_1 = _b.sent();
                    console.error("Failed to fetch chart data:", error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchSearchedData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var search_1, updatedDashlets_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!(currentTimerRefresh > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getSearchedDashlet()];
                    case 1:
                        search_1 = _a.sent();
                        if (search_1 && currentRowConfig) {
                            if (JSON.stringify(search_1) !== JSON.stringify(currentRow === null || currentRow === void 0 ? void 0 : currentRow.chartData)) {
                                updatedDashlets_1 = rowMeta.map(function (dashlet) {
                                    return dashlet.id === item.id
                                        ? __assign(__assign({}, dashlet), { chartData: __assign({}, search_1) }) : dashlet;
                                });
                                setAllDashlets(function (prevDashlets) {
                                    var updatedDashletsState = __assign({}, prevDashlets);
                                    for (var key in updatedDashletsState) {
                                        if (updatedDashletsState[key].id === rowId) {
                                            updatedDashletsState[key] = __assign(__assign({}, updatedDashletsState[key]), { meta: updatedDashlets_1 });
                                            break;
                                        }
                                    }
                                    updatedDashletsState &&
                                        saveDashletPreferences({
                                            dashlets: updatedDashletsState,
                                            isNew: false,
                                        })
                                            .unwrap()
                                            .catch(function (error) {
                                            console.error("Failed to save dashlet preference:", error);
                                        });
                                    return updatedDashletsState;
                                });
                            }
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Error fetching searched dashlet:", error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (currentTimerRefresh > 0) {
            fetchSearchedData();
            var intervalId_1 = setInterval(fetchSearchedData, currentTimerRefresh);
            return function () {
                clearInterval(intervalId_1);
            };
        }
    }, [myDashlets, currentRowConfig, currentTimerRefresh, rowMeta]);
    // if (item?.component !== "widget/dashlet/chart") return null;
    if ((item === null || item === void 0 ? void 0 : item.component) === "widget/KPIAffaires" ||
        (item === null || item === void 0 ? void 0 : item.component) === "widget/KPICalls" ||
        (item === null || item === void 0 ? void 0 : item.component) === "widget/KPICases" ||
        (item === null || item === void 0 ? void 0 : item.component) === "widget/KPILeads")
        return (_jsx(_Fragment, { children: _jsx(WidgetDisplay, { widget: {
                    id: item.id,
                    rowId: rowId,
                    rowMeta: rowMeta,
                    type: item.component,
                    payload: {
                        id: item.id,
                        module: item.module,
                        period: item.period || "semaine",
                        limit: item.limit || "La semaine dernière",
                        cumulatif: item.cumulatif || "non",
                        isInDashlet: true,
                        chartData: chartData,
                        chartType: chartType,
                        title: title,
                        kpiType: item.kpiType,
                        value: value,
                        refresh: refresh,
                        allDashlets: allDashlets,
                        dashlets: getDashlets(),
                    },
                } }, item.id) }));
    else {
        return (_jsx(WidgetDisplay, { widget: {
                id: item.id,
                rowId: rowId,
                rowMeta: rowMeta,
                type: item.component || "widget/dashlet/chart",
                payload: {
                    id: item.id,
                    module: item.module,
                    chartData: ((_d = chartData === null || chartData === void 0 ? void 0 : chartData.data) === null || _d === void 0 ? void 0 : _d.dashlets)
                        ? (_e = chartData === null || chartData === void 0 ? void 0 : chartData.data) === null || _e === void 0 ? void 0 : _e.dashlets
                        : chartData,
                    chartType: chartType,
                    title: title,
                    value: value,
                    refresh: refresh,
                    allDashlets: allDashlets,
                    dashlets: getDashlets(),
                },
            } }, item.id));
    }
};
//export default ChartWidgetDisplay;
export default memo(ChartWidgetDisplay);
